// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__3C-nk"};